import * as Dialog from 'radix-ui/dialog';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './styles.css';
import { Button } from '../Button/Button';
import { Coffee } from 'lucide-react';
import { useDonation } from 'context/DonationContext';
import { ROUTES } from 'constants/routes';
import { DialogOverlay } from 'components/DialogOverlay';

export function DonationDialog() {
  const { t } = useTranslation();
  const { isOpen, closeDialog } = useDonation();
  const navigate = useNavigate();

  const metadata = {
    title: t('donationDialog.title'),
    text: t('donationDialog.text'),
    section: t('donationDialog.section'),
    cta: t('donationDialog.cta'),
  };

  function handleOpenChange(open) {
    if (!open) closeDialog('dismiss');
  }

  function handleDonate() {
    closeDialog('supported');
    navigate(ROUTES.support);
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Dialog.Portal>
        <DialogOverlay />
        <Dialog.Content className="DialogContent">
          <Dialog.Title className="DialogTitle">{metadata.title}</Dialog.Title>

          <div className="TextContainer">
            <Dialog.Description className="DialogDescription">{metadata.text}</Dialog.Description>
            <span className="DialogDescription">{metadata.section}</span>
          </div>
          <Button onClick={handleDonate}>
            <Coffee />
            {metadata.cta}
          </Button>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
